export default __webpack_public_path__ + "static/media/EndMillOverviewImg.d8df211b.jpg";